import { connect } from 'react-redux';

import { Modal } from 'UIPackage/ModalModule/components/Modal';

import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import styles from './AccessRestrictionNoticeModal.module.scss';
import { IRootState } from '../interfaces/IRootState';
import {
  getKnmAccessNoticeErpId,
  getKnmAccessNoticeKnoOrganizationName,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';

interface IAccessRestrictionNoticeModalProps {
  visible?: boolean;
}

interface IAccessRestrictionNoticeModalStoreProps {
  erpId: string | undefined;
  knoOrganizationName: string | undefined;
}

const AccessRestrictionNoticeModalWithoutStore = ({
  visible,
  knoOrganizationName,
  erpId,
}: IAccessRestrictionNoticeModalProps & IAccessRestrictionNoticeModalStoreProps) => {
  return (
    <Modal visible={visible} closeButtonClassName={styles.CloseButton}>
      <ModalHeader title="Уведомление об ограничении доступа" />
      <ModalBody size="content">
        <div className={styles.Body}>
          <span className={styles.AttentionIcon}></span>
          <span className={styles.Bold}>Уважаемый пользователь!</span>
          <span>Доступ к сведениям паспорта мероприятия ограничен.</span>
          <span>
            Предоставление доступа к паспорту мероприятия № {erpId} осуществляется должностными и иными уполномоченными
            лицами контрольного (надзорного) органа
          </span>
          <span>«{knoOrganizationName}»</span>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state: IRootState): IAccessRestrictionNoticeModalStoreProps => ({
  erpId: getKnmAccessNoticeErpId(state),
  knoOrganizationName: getKnmAccessNoticeKnoOrganizationName(state),
});

export const AccessRestrictionNoticeModal = connect(mapStateToProps)(AccessRestrictionNoticeModalWithoutStore);
